import { createSelector } from 'reselect';
import { getKBEnabled } from '../operators/getKBEnabled';
// @ts-expect-error untyped file
import { getWelcomeMessage } from '../../selectors/widgetDataSelectors/getWelcomeMessage';
export const getKnowledgeBaseEnabled = createSelector([getWelcomeMessage], message => getKBEnabled(message));